export const SELECTION_MODE_INCLUDE = 'include';
export const SELECTION_MODE_EXCLUDE = 'exclude';

export const SELECTION_STATUS_ALL = 'all';
export const SELECTION_STATUS_SOME = 'some';
export const SELECTION_STATUS_NONE = 'none';
